import React from "react";

const Footer = () => {
  return (
    <footer className="page-footer text-center text-md-left pt-0">
      <div className="top-footer-color rgba-orange-strong">
        <div className="container">
          <div className="row py-4 d-flex align-items-center">
            <div className=" mb-2 col-md-6 col-lg-5 text-center text-md-left mb-md-0">
              <h6 className=" white-text font-weight-bolder">
                Get connected with us on social networks!
              </h6>
            </div>

            <div className="col-md-6 col-lg-7 text-center text-md-right">
              <a
                className="p-2 m-2 fa-lg fb-ic ml-0"
                href="https://www.facebook.com/inspiregraphics19"
                rel="noopener noreferrer"
                target="_blank"
              >
                <i className="fab fa-facebook-f white-text mr-lg-4"></i>
              </a>

              <a
                className="p-2 m-2 fa-lg tw-ic"
                rel="noopener noreferrer"
                href="https://twitter.com/guptaashwanee"
                target="_blank"
              >
                <i className="fab fa-twitter white-text mr-lg-4"></i>
              </a>

              <a
                className="p-2 m-2 fa-lg gplus-ic"
                rel="noopener noreferrer"
                href="https://github.com/guptaashwanee"
                target="_blank"
              >
                <i className="fab fa-github white-text mr-lg-4"></i>
              </a>

              <a
                className="p-2 m-2 fa-lg li-ic"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/guptaashwanee/"
                target="_blank"
              >
                <i className="fab fa-linkedin-in white-text mr-lg-4"></i>
              </a>

              <a
                className="p-2 m-2 fa-lg ins-ic"
                rel="noopener noreferrer"
                href="https://www.instagram.com/inspiregraphics19/"
                target="_blank"
              >
                <i className="fab fa-instagram white-text mr-lg-4"></i>
              </a>
              <a
                className="p-2 m-2 fa-lg ins-ic"
                rel="noopener noreferrer"
                href="https://mail.google.com/mail/?view=cm&fs=1&to=ashwanee2001gupta@gmail.com&su=INFO @ INSPIRE GRAPHICS &body=Hi there Inspire Graphics....&bcc=inspiregraphics.sati@gmail.com"
                target="_blank"
              >
                <i className="fas fa-envelope-open-text white-text mr-lg-4"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 mb-4 text-center text-md-left">
        <div className="row mt-3">
          <div className="col-md-3 col-lg-4 col-xl-3 mb-4">
            <h6 className="spacing font-weight-bold">
              <strong>Inspire Graphics</strong>
            </h6>
            <hr
              className="pink accent-2 mb-4 mt-0 d-inline-block mx-auto"
              style={{ width: 60 }}
            />
            <p className="font-weight-bolder">
              INSPIRE CODE & GRAPHIC is organize & managed by the INSPIRE team.
              The purpose is to provide an extremely rich graphical user
              interface for creating & publishing a blog. With clean &
              maintainable code, uses modern JavaScript(ES6) features
            </p>
          </div>

          <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
            <h6 className="spacing font-weight-bold">
              <strong>Products</strong>
            </h6>
            <hr
              className="pink accent-2 mb-4 mt-0 d-inline-block mx-auto"
              style={{ width: 60 }}
            />
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                Graphics Design
              </a>
            </p>
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                Visual Effects
              </a>
            </p>
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                UI/UX Development
              </a>
            </p>
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                Technical Work
              </a>
            </p>
          </div>

          <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <h6 className="spacing font-weight-bold">
              <strong>Useful links</strong>
            </h6>
            <hr
              className="pink accent-2 mb-4 mt-0 d-inline-block mx-auto"
              style={{ width: 60 }}
            />
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                Your Account
              </a>
            </p>
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                Become an Affiliate
              </a>
            </p>
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                Shipping Rates
              </a>
            </p>
            <p>
              <a href="#!" className="footer-link font-weight-bolder">
                Help
              </a>
            </p>
          </div>

          <div className="col-md-4 col-lg-3 col-xl-3">
            <h6 className="spacing font-weight-bold">
              <strong>Contact</strong>
            </h6>
            <hr
              className="pink accent-2 mb-4 mt-0 d-inline-block mx-auto"
              style={{ width: 60 }}
            />
            <p className="font-weight-bolder">
              <i className="fas fa-home mr-3 "></i> S.A.T.I. VIDISHA
              464001(M.P.)
            </p>
            <p>
              <i className="fas fa-envelope mr-3"></i>{" "}
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=info.inspirecg@gmail.com&su=INFO @ INSPIRE CODE-GRAPHICS &body=Hi there Inspire Graphics....&bcc=ashwanee2001gupta@gmail.com"
                className="footer-link font-weight-bolder"
              >
                info.inspirecg@gmail.com
              </a>
            </p>
            <p>
              <i className="fas fa-phone mr-3" aria-hidden="true"></i>{" "}
              <a
                href="tel:+91-8827920790"
                className="footer-link font-weight-bolder"
              >
                + 91 882 792 079 0
              </a>
            </p>
            <p>
              <i className="fab fa-whatsapp mr-3" aria-hidden="true"></i>{" "}
              <a
                href="https://api.whatsapp.com/send?phone=918827920790&text=Hello%20Inspire%20Code%20Graphics%20-&source=&data="
                className="footer-link font-weight-bolder"
              >
                + 91 882 792 079 0
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="footer-copyright py-3 text-center">
        <div>
          &copy; Copyright <strong>INSPIRE GRAPHICS</strong>. All Rights
          Reserved
        </div>
        <div className="container-fluid pb-1">
          Designed & Maintained by{" "}
          <a
            rel="noopener noreferrer"
            href="https://github.com/guptaashwanee"
            target="_blank"
            className="footer-link font-weight-bolder"
          >
            Ashwanee Gupta
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
